import type { RatesSettings } from './types.js';

export const CEB_REV_2026_DEFAULTS: RatesSettings = {
  version: 1,
  tariff: {
    revisionLabel: 'CEB Domestic Tariff Revision 2026 (effective 11 May 2026)',
    categories: [
      {
        id: 'A',
        label: '0 – 60 kWh',
        minUnits: 0,
        maxUnits: 60,
        blocks: [
          { fromUnits: 0, toUnits: 30, energyRateLkr: 5.0, fixedChargeLkr: 80.0 },
          { fromUnits: 30, toUnits: 60, energyRateLkr: 9.0, fixedChargeLkr: 210.0 },
        ],
      },
      {
        id: 'B',
        label: '61 – 180 kWh',
        minUnits: 61,
        maxUnits: 180,
        blocks: [
          { fromUnits: 0, toUnits: 60, energyRateLkr: 14.0, fixedChargeLkr: null },
          { fromUnits: 60, toUnits: 90, energyRateLkr: 20.0, fixedChargeLkr: 400.0 },
          { fromUnits: 90, toUnits: 120, energyRateLkr: 28.0, fixedChargeLkr: 1000.0 },
          { fromUnits: 120, toUnits: 180, energyRateLkr: 44.0, fixedChargeLkr: 1500.0 },
        ],
      },
      {
        id: 'C',
        label: 'Above 180 kWh',
        minUnits: 181,
        maxUnits: null,
        blocks: [
          { fromUnits: 0, toUnits: 180, energyRateLkr: 32.5, fixedChargeLkr: null },
          { fromUnits: 180, toUnits: null, energyRateLkr: 100.0, fixedChargeLkr: 2500.0 },
        ],
      },
    ],
  },
  fans: {
    normalWatts: 70,
    atombergWatts: 28,
    defaultHoursPerDay: 24,
    daysPerMonth: 30,
    effectiveFansDivisor: 2,
  },
  maintenance: {
    electricianLkr: 1500,
    condenserLkr: 1500,
    cycleMonths: 9,
  },
  sscl: {
    ratePercent: 2.5,
  },
};
